import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { Delivery, InboxDelivery } from '../../../../../core/models';
import { addToFavorite, removeFavorite } from './store/favorite-btn.actions';
import { HelperService } from '../../../../../core/services/helper.service';

@Component({
  standalone: false,
  selector: 'pptl-favorite-btn',
  templateUrl: 'favorite-btn.component.html',
  styleUrls: ['favorite-btn.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FavoriteBtnComponent {
  curDelivery: InboxDelivery;
  prevDelivery: InboxDelivery;

  private onToogleClick$ = new Subject();

  @Input()
  set delivery(delivery: Delivery) {
    if (this.isFavouriteFlagChanged(delivery)) {
      this.curDelivery = HelperService.cloneDelivery(<InboxDelivery>delivery);
    }
  }

  constructor(private store: Store<any>) {
    this.subscribeOnToggle();
  }

  onToggleFavorite($event: Event): void {
    $event.stopPropagation();

    if (!this.curDelivery.expired) {
      this.curDelivery = this.getToggledDelivery(this.curDelivery);

      this.onToogleClick$.next(true);
    }
  }

  getToggledDelivery(delivery: InboxDelivery) {
    return { ...delivery, favourite: !delivery.favourite };
  }

  isFavouriteFlagChanged(newDelivery) {
    return (
      !this.curDelivery ||
      (this.curDelivery.deliveryKeyCode !== newDelivery.deliveryKeyCode &&
        this.curDelivery.favourite !== newDelivery.favorite)
    );
  }

  private subscribeOnToggle() {
    this.onToogleClick$.pipe(debounceTime(50)).subscribe(() => {
      if (!this.prevDelivery || this.prevDelivery.favourite !== this.curDelivery.favourite) {
        if (this.curDelivery.favourite) {
          this.store.dispatch(addToFavorite({ delivery: this.curDelivery }));
        } else {
          this.store.dispatch(
            removeFavorite({ deliveryKeyCode: this.curDelivery.deliveryKeyCode }),
          );
        }
      }

      this.prevDelivery = this.curDelivery;
    });
  }
}
